import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

/** The whole card is the hit target; the "Click here" button is `pointer-events-none`. */
@Component({
  selector: 'app-onboarding-concern-card',
  templateUrl: './onboarding-concern-card.component.html',
  imports: [ButtonCtaComponent],
  host: { class: 'tw-flex tw-flex-1' },
})
export class OnboardingConcernCardComponent {
  /** An `AppConfig.Shared.Regimen.Class` value, echoed back on selection. */
  readonly concernClass: InputSignal<string> = input.required<string>();

  readonly iconUrl: InputSignal<string> = input.required<string>();

  readonly concernSelected: OutputEmitterRef<string> = output<string>();

  protected handleSelect(): void {
    this.concernSelected.emit(this.concernClass());
  }
}
